import {observer} from "mobx-react";
import * as React from "react";
import {withAppStores} from "../../../../AppStores";
import type {Xyicon} from "../../../../data/models/Xyicon";
import type {AppState} from "../../../../data/state/AppState";
import {Permission} from "../../../../generated/api/base";
import {FieldV5} from "../../details/FieldV5";
import {XyiconModelFieldV5} from "../../details/datatypes/XyiconModelFieldV5";

interface IXyiconDefaultFieldsProps {
	readonly item: Xyicon;
	readonly appState?: AppState;
}

@withAppStores("appState", "transport")
@observer
export class XyiconDefaultFieldsV5 extends React.Component<IXyiconDefaultFieldsProps> {
	private get hasPermission() {
		const {item, appState} = this.props;

		return appState.actions.getModuleTypePermission(item.typeId, item.ownFeature, item.portfolioId) > Permission.View;
	}

	public override render() {
		const {item, appState} = this.props;

		return (
			<>
				<FieldV5
					label={appState.actions.getRefIdName(item.ownFeature)}
					className="stucked"
				>
					{item.refId}
				</FieldV5>
				<FieldV5 label="Type">{appState.actions.getTypeName(item.typeId)}</FieldV5>
				<FieldV5 label="Model">
					<XyiconModelFieldV5
						disabled={!this.hasPermission}
						xyicons={[item]}
					/>
				</FieldV5>
			</>
		);
	}
}
